import React from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../components/WMS/Mobile/Popup";
import {Grid} from "@mui/material";
import TextEmphasisBloc from "../../../../components/WMS/TextEmphasisBloc";
import CustomButton from "../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";
import {ReactComponent as ScanBoxIcon} from "assets/img/wms/scanBox.svg"
import WMSCarrierIcon from "../../../../components/WMS/WMSCarrierIcon";

CcShipmentModal.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    selectedShipment: PropTypes.object.isRequired,
    handleManualChoice: PropTypes.func.isRequired
};

function CcShipmentModal({open, setOpen, handleClose, selectedShipment, handleManualChoice}) {
    return (
        <Popup
            open={open}
            onClose={handleClose}
            icon={<ScanBoxIcon />}
            title={<FormattedMessage id={"wms.ccReception.shipmentModal.title"} values={{shipmentNumber: selectedShipment.externalDeliveryNumber}}/>}
            subtitle={<FormattedMessage id={"wms.ccReception.shipmentModal.subtitle"}/>}
        >
            <Grid container direction={'column'} gap={"8px"}>
                <TextEmphasisBloc
                    leftPart={
                    <>
                        <span>{selectedShipment.shippingMethod.name} </span>
                        <WMSCarrierIcon
                            iconName={selectedShipment.shippingMethod.carrierIcon}
                            altName={selectedShipment.shippingMethod.carrierIcon}
                        />
                    </>
                }
                />

                <CustomButton onClick={() => handleManualChoice()} fullWidth><FormattedMessage id={"wms.ccReception.shipmentModal.manualChoiceButtonLabel"}/></CustomButton>
                <CustomButton onClick={() => handleClose()} fullWidth color={"default"}><FormattedMessage id={"wms.ccReception.shipmentModal.cancel"}/></CustomButton>
            </Grid>
        </Popup>
    );
}

export default CcShipmentModal;
